import styled, { css } from "styled-components";

/**
 * Wrapper for the mobile `CustomKeyboard` that reserves layout space while
 * the keyboard should be out of the way (e.g. while a Braintree Hosted Field
 * is focused or a deposit is loading). Using `visibility: hidden` rather than
 * unmounting keeps input fields above from shifting when the keyboard toggles.
 */
export const KeyboardContainer = styled.div<{ isHidden?: boolean }>`
  ${({ isHidden }) =>
    isHidden &&
    css`
      visibility: hidden;
      pointer-events: none;
    `}
`;
